import { ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { ITimeline } from "../interfaces/itimeline";
import { EventService } from "../services/event.service";
import { Observable } from "rxjs";

@Injectable()
export class EventsResolver {
    constructor(private eventService: EventService) {

    }

    resolve(route: ActivatedRouteSnapshot): Observable<ITimeline> {
        return this.eventService.getEvents();
    }
}